function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var t = function t(_t, e, i) {
    return _t.reduce(function (t, a, r) {
      var h = Math.floor(r / e);
      return h > 0 && i || (t[h] || (t[h] = []), t[h].push(a)), t;
    }, []);
  },
  e = function e(_ref) {
    var e = _ref.elements,
      i = _ref.tilesInFirstPage,
      a = _ref.onlyOnePage,
      r = _ref.isLastPageDifferentFromFirstPage,
      h = _ref.defaultWidth,
      n = _ref.defaultHeight,
      s = _ref.lastPageWidth,
      o = _ref.lastPageHeight;
    var l = t(e, i, a);
    return l.map(function (t, e) {
      return t.map(function (t) {
        var i = e === l.length - 1,
          a = r && i ? s : h,
          g = r && i ? o : n;
        return Object.assign(Object.assign({}, t), {
          height: g,
          width: a
        });
      });
    });
  };
function i(t) {
  if (0 === t.length) return null;
  var e = {};
  var i = t[0],
    a = 1;
  for (var _r = 0; _r < t.length; _r++) {
    var _h = t[_r];
    null === e[_h] ? e[_h] = 1 : e[_h]++, e[_h] > a && (i = _h, a = e[_h]);
  }
  return i;
}
var a = function a(t) {
    return i(t.filter(function (t) {
      var e, i;
      return (null === (e = t.track) || void 0 === e ? void 0 : e.width) && (null === (i = t.track) || void 0 === i ? void 0 : i.height);
    }).map(function (t) {
      var e, i;
      return ((null === (e = t.track) || void 0 === e ? void 0 : e.width) || 1) / ((null === (i = t.track) || void 0 === i ? void 0 : i.height) || 1);
    }));
  },
  r = function r(t, e, i, a, _r3) {
    if (t < 0 || e < 0) throw new Error("Container must have a non-negative area");
    if (i < 1 || !Number.isInteger(i)) throw new Error("Number of shapes to place must be a positive integer");
    var h = a && _r3 && a / _r3;
    if (void 0 !== h && isNaN(h)) throw new Error("Aspect ratio must be a number");
    var n = {
      area: 0,
      cols: 0,
      rows: 0,
      width: 0,
      height: 0
    };
    if (void 0 !== h) for (var _a = i; _a > 0; _a += -1) {
      var _r2 = Math.ceil(i / _a);
      var _s = void 0,
        _o = void 0;
      t / (_a * h) <= e / _r2 ? (_s = t / _a, _o = _s / h) : (_o = e / _r2, _s = _o * h);
      var _l = _s * _o;
      _l > n.area && (n = {
        area: _l,
        width: _s,
        height: _o,
        rows: _r2,
        cols: _a
      });
    }
    return n;
  },
  h = function h(_ref2) {
    var t = _ref2.parentWidth,
      e = _ref2.parentHeight,
      i = _ref2.count,
      a = _ref2.maxCount,
      r = _ref2.aspectRatio;
    var h = 0,
      n = 0,
      s = 0,
      o = 0,
      l = !1,
      g = 0,
      d = 0;
    var u = Math.min(Math.ceil(Math.sqrt(i * (t / e) / (r.width / r.height))), a);
    var c = t / u,
      f = c / (r.width / r.height);
    f > e && (f = e, c = f / (r.height / r.width));
    var P = Math.floor(e / f);
    if (n = f, h = c, g = Math.min(i, P * u), d = i % (P * u), l = d > 0 && i > P * u, l) {
      var _i = t / Math.min(Math.ceil(Math.sqrt(d * (t / e) / (r.width / r.height))), a),
        _h2 = _i / (r.width / r.height);
      _h2 > e && (_h2 = e, _i = _h2 / (r.height / r.width)), o = _h2, s = _i;
    }
    return {
      tilesInFirstPage: g,
      defaultWidth: h,
      defaultHeight: n,
      lastPageWidth: s,
      lastPageHeight: o,
      isLastPageDifferentFromFirstPage: l
    };
  },
  n = function n(_ref3) {
    var t = _ref3.parentWidth,
      e = _ref3.parentHeight,
      i = _ref3.count,
      a = _ref3.maxCount,
      h = _ref3.aspectRatio;
    var n = 0,
      s = 0,
      o = 0,
      l = 0,
      g = !1,
      d = 0,
      u = 0;
    var _r4 = r(t, e, Math.min(i, a), h.width, h.height),
      c = _r4.width,
      f = _r4.height;
    if (n = c, s = f, d = Math.min(i, a), u = i % a, g = u > 0 && i > a, g) {
      var _r5 = r(t, e, u, h.width, h.height),
        _i2 = _r5.width,
        _a2 = _r5.height;
      o = _i2, l = _a2;
    }
    return {
      tilesInFirstPage: d,
      defaultWidth: n,
      defaultHeight: s,
      lastPageWidth: o,
      lastPageHeight: l,
      isLastPageDifferentFromFirstPage: g
    };
  },
  s = function s(_ref4) {
    var t = _ref4.parentWidth,
      e = _ref4.parentHeight,
      i = _ref4.count,
      a = _ref4.maxCount,
      r = _ref4.aspectRatio;
    var h = 0,
      n = 0,
      s = 0,
      o = 0,
      l = !1,
      g = 0,
      d = 0;
    var u = Math.min(Math.ceil(Math.sqrt(i * (r.width / r.height) / (t / e))), a),
      c = e / u,
      f = c * (r.width / r.height),
      P = Math.floor(t / f);
    if (h = f, n = c, g = Math.min(i, u * P), d = i % (u * P), l = d > 0 && i > u * P, l) {
      var _i3 = e / Math.min(Math.ceil(Math.sqrt(d * (r.width / r.height) / (t / e))), a);
      o = _i3, s = _i3 * (r.width / r.height);
    }
    return {
      tilesInFirstPage: g,
      defaultWidth: h,
      defaultHeight: n,
      lastPageWidth: s,
      lastPageHeight: o,
      isLastPageDifferentFromFirstPage: l
    };
  };
function o(_ref5) {
  var t = _ref5.count,
    e = _ref5.parentWidth,
    i = _ref5.parentHeight,
    a = _ref5.maxTileCount,
    o = _ref5.maxRowCount,
    l = _ref5.maxColCount,
    g = _ref5.aspectRatio;
  var d = 0,
    u = 0,
    c = 0,
    f = 0,
    P = !1,
    p = 0;
  if (0 === t) return {
    tilesInFirstPage: p,
    defaultWidth: d,
    defaultHeight: u,
    lastPageWidth: c,
    lastPageHeight: f,
    isLastPageDifferentFromFirstPage: P
  };
  if (a) {
    var _n = n({
      parentWidth: e,
      parentHeight: i,
      count: t,
      maxCount: a,
      aspectRatio: g
    });
    p = _n.tilesInFirstPage;
    d = _n.defaultWidth;
    u = _n.defaultHeight;
    c = _n.lastPageWidth;
    f = _n.lastPageHeight;
    P = _n.isLastPageDifferentFromFirstPage;
  } else if (o) {
    var _s2 = s({
      parentWidth: e,
      parentHeight: i,
      count: t,
      maxCount: o,
      aspectRatio: g
    });
    p = _s2.tilesInFirstPage;
    d = _s2.defaultWidth;
    u = _s2.defaultHeight;
    c = _s2.lastPageWidth;
    f = _s2.lastPageHeight;
    P = _s2.isLastPageDifferentFromFirstPage;
  } else if (l) {
    var _h3 = h({
      parentWidth: e,
      parentHeight: i,
      count: t,
      maxCount: l,
      aspectRatio: g
    });
    p = _h3.tilesInFirstPage;
    d = _h3.defaultWidth;
    u = _h3.defaultHeight;
    c = _h3.lastPageWidth;
    f = _h3.lastPageHeight;
    P = _h3.isLastPageDifferentFromFirstPage;
  } else {
    var _r6 = r(e, i, t, g.width, g.height),
      _a3 = _r6.width,
      _h4 = _r6.height;
    d = _a3, u = _h4, p = t;
  }
  return {
    tilesInFirstPage: p,
    defaultWidth: d,
    defaultHeight: u,
    lastPageWidth: c,
    lastPageHeight: f,
    isLastPageDifferentFromFirstPage: P
  };
}
var l = function l(t, e, i) {
    var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    if (!t || !e || !i) return [];
    var r = [];
    var _iterator = _createForOfIteratorHelper(t),
      _step;
    try {
      var _loop = function _loop() {
        var h = _step.value;
        if (void 0 === h.videoTrack && h.audioTrack && e[h.audioTrack] ? r.push({
          peer: h
        }) : h.videoTrack && e[h.videoTrack] ? r.push({
          track: e[h.videoTrack],
          peer: h
        }) : a || r.push({
          peer: h
        }), h.auxiliaryTracks.length > 0 && h.auxiliaryTracks.forEach(function (t) {
          var i = e[t];
          "video" === (null == i ? void 0 : i.type) && "regular" === (null == i ? void 0 : i.source) && r.push({
            track: i,
            peer: h
          });
        }), i(h) && h.auxiliaryTracks.length > 0) {
          var _t2 = h.auxiliaryTracks.find(function (t) {
            var i = e[t];
            return "video" === (null == i ? void 0 : i.type) && "screen" === (null == i ? void 0 : i.source);
          });
          _t2 && r.push({
            track: e[_t2],
            peer: h
          });
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return r;
  },
  g = function g(_ref6) {
    var t = _ref6.layerDefinitions,
      e = _ref6.width,
      i = _ref6.height;
    var a,
      r = Number.MAX_VALUE;
    var _iterator2 = _createForOfIteratorHelper(t),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _step2.value,
          _h5 = _step2$value.resolution,
          _n2 = _step2$value.layer;
        var _t3 = Math.abs(e - (_h5.width || 0)) + Math.abs(i - (_h5.height || 0));
        _t3 < r && (r = _t3, a = _n2);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return a;
  };
export { o as calculateLayoutSizes, t as chunk, e as chunkElements, g as getClosestLayer, a as getModeAspectRatio, h as getTileSizesWithColConstraint, n as getTileSizesWithPageConstraint, s as getTileSizesWithRowConstraint, l as getVideoTracksFromPeers, r as largestRect, i as mode };